import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
//import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { router } from './core/routes/app_routes.js';
import { RouterProvider } from 'react-router-dom';
import { store, persistor } from './features/presentation/state/store.js';
import { PersistGate } from "redux-persist/integration/react";
import 'primeicons/primeicons.css';
import { Toaster } from 'sonner';

const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <React.StrictMode>
//     <Provider store={store}>
//       <PersistGate loading={null} persistor={persistor}>
//         <RouterProvider router={router} />
//       </PersistGate>
//     </Provider>
//   </React.StrictMode>
// );

root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <Toaster 
        theme="dark"
        position="top-right"
      />
      <RouterProvider router={router} />
    </PersistGate>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
